export const tr = {
    'predictor-error': 'Tahmin geçici olarak geçersiz',
    'reach-title': '7 günlük kapsam tahmini'
};
